<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">image</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.pictures' | translate}}</span>
      </div>
      <!-- / APP TITLE -->
      <button mat-raised-button
        (click)="newPicture()"
        class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'picture.add_new_picture' | translate}}</span>
      </button>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg" fusePerfectScrollbar>
      <!-- / SEARCH -->
      <div class="column has-text-centered">
        @for (image of _albums; track image; let i = $index) {
          <div class="img-row">
            <img class="img-frame" [src]="getImage(image.src)" (click)="open(i)"/>
            <div class="button-row">
              @if (pictures[ i ].edit) {
                <button mat-icon-button style="width: 50%" (click)="deletePicture(i)">
                  <mat-icon aria-label="Delete">delete</mat-icon>
                </button>
              }
              <button mat-icon-button  (click)="open(i)">
                <mat-icon aria-label="Fullscreen">fullscreen</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
